import type { AxiosResponse } from "axios"

const getFilenameFromResponse = (response: AxiosResponse<any, any, {}>) => {
	const contentDisposition = response.headers["content-disposition"]
	if (!contentDisposition) {
		return undefined
	}
	const parts = contentDisposition.split("filename=")
	if (parts.length < 2) {
		return undefined
	}
	const fileName = parts[1].split(";")[0].trim().replace("UTF-8''", "")
	return fileName
}

const handleDownloadResult = (
	fileNameFallback: string,
	response: AxiosResponse<any, any, {}>
) => {
	const href = window.URL.createObjectURL(response.data)

	const anchorElement = document.createElement("a")

	const fileName = getFilenameFromResponse(response) ?? fileNameFallback

	anchorElement.href = href
	anchorElement.download = fileName

	document.body.appendChild(anchorElement)
	anchorElement.click()

	document.body.removeChild(anchorElement)
	window.URL.revokeObjectURL(href)
}

export default handleDownloadResult
